import {
  Directive, Input, TemplateRef, ViewContainerRef, OnDestroy, ChangeDetectorRef
} from '@angular/core';
import { MediaObserver, BreakPointRegistry } from '@angular/flex-layout';
import { Subject } from 'rxjs';
import {
  startWith, switchMap, map, distinctUntilChanged
} from 'rxjs/operators';

@Directive({
  selector: '[sondermindMediaQueryIf]',
  standalone: false
})
export class MediaQueryIfDirective implements OnDestroy {
  constructor(
    private template: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private breakpoints: BreakPointRegistry,
    private changeRef: ChangeDetectorRef,
    private mediaObserver: MediaObserver,
  ) {}

  private hasView = false;
  private matcher = new Subject<string>();
  private subscription = this.matcher
    .pipe(
      map((alias) => this.breakpoints.findByAlias(alias).mediaQuery),
      switchMap((mq) => this.mediaObserver.asObservable().pipe(
        map((_) => this.mediaObserver.isActive(mq)),
        distinctUntilChanged(),
        startWith(this.mediaObserver.isActive(mq))
      )),
    )
    .subscribe((matches) => (matches ? this.createView() : this.destroyView()));

  @Input()
  set sondermindMediaQueryIf(value: string) {
    this.matcher.next(value);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  private createView() {
    if (!this.hasView) {
      this.viewContainer.createEmbeddedView(this.template);
      this.changeRef.markForCheck();
      this.hasView = true;
    }
  }

  private destroyView() {
    if (this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
